var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 18 20",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.0714286 10.75h-.9642857v-2.8125c0-3.2734375-2.7401786-5.9375-6.1071429-5.9375-3.36696429 0-6.10714286 2.6640625-6.10714286 5.9375v2.8125h-.96428571c-1.06473214 0-1.92857143.8398438-1.92857143 1.875v7.5c0 1.0351562.86383929 1.875 1.92857143 1.875h14.14285717c1.0647321 0 1.9285714-.8398438 1.9285714-1.875v-7.5c0-1.0351562-.8638393-1.875-1.9285714-1.875zm-4.0714286.25h-6v-3c0-1.65416667 1.3458333-3 3-3s3 1.34583333 3 3z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.114afc01.svg";
export { ForwardRef as ReactComponent };